<template>
  <div>
    <validation-observer :ref="`${code}-validator`">
      <section-title
        content="III. Información Relevante del Historial General, al Proceso de Evaluación en AT"
        has-line
      />
      <div>
        <div class="color-black font-14 my-1">
          Componente Familiar constituído por:
        </div>
        <validation-provider :rules="'required'" v-slot="{ errors }">
          <custom-text-area
            id="familyComponentConstitutedByInput"
            v-model="value.familyComponentConstitutedBy"
            placeholder="Escribe un comentario"
            :disabled="isReadOnly"
            :maxlength="3000"
            :error="errors[0]"
            :custom-error-msg="'Este campo es requerido'"
          />
        </validation-provider>
      </div>

      <div class="my-3">
        <section-title
          icon="fas fa-plus"
          container-class="tag-badge-main-info mt-2 mb-2"
          content="Historial Médico"
        />
        <div class="px-3">
          <div
            v-for="(item, key) in value.medicalHistory"
            :key="key"
            class="my-3 border-bottom"
          >
            <div class="row">
              <div class="col-md-4">
                <validation-provider v-slot="{ errors }" rules="required">
                  <div class="row mb-3 mb-md-0">
                    <div class="col-7 d-flex align-items-center">
                      {{ item.codeName }}
                    </div>
                    <div class="col">
                      <custom-radio
                        is-question-list
                        class="radio-button-container"
                        v-model="item.answer"
                        :key="item.answer"
                        :options="yesNoOptions(item.answer)"
                        :disabled="isReadOnly"
                        :customErrorMsg="''"
                        @input="onQuestionChange($event, item)"
                      />
                    </div>
                    <div class="col-12" v-if="Boolean(errors[0])">
                      <Error
                        variant="no-border"
                        message="Favor de seleccionar una opción."
                      />
                    </div>
                  </div>
                </validation-provider>
              </div>
              <div class="col-md col-12">
                <validation-provider
                  v-slot="{ errors }"
                  :rules="item.answer ? 'required' : ''"
                >
                  <input
                    class="form-control"
                    :class="{
                      'border-danger': item.answer && Boolean(errors[0]),
                    }"
                    placeholder="Explique"
                    :disabled="isReadOnly || !item.answer"
                    v-model="item.explain"
                  />
                  <Error
                    v-if="item.answer && Boolean(errors[0])"
                    variant="no-border"
                    message="Campo explique es requerido."
                  />
                </validation-provider>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="my-3">
        <div class="color-black font-14 my-1">
          Mantiene seguimiento médico con:
        </div>
        <validation-provider :rules="'required'" v-slot="{ errors }">
          <custom-text-area
            id="maintainsMedicalMonitoringWithInput"
            v-model="value.maintainsMedicalMonitoringWith"
            placeholder="Escribe un comentario"
            :disabled="isReadOnly"
            :maxlength="3000"
            :error="errors[0]"
            :custom-error-msg="'Este campo es requerido'"
          />
        </validation-provider>
      </div>

      <div class="my-3">
        <div class="color-black font-14 my-1">Diagnóstico(s):</div>
        <validation-provider :rules="'required'" v-slot="{ errors }">
          <custom-text-area
            id="diagnosticsInput"
            v-model="value.diagnostics"
            placeholder="Escribe un comentario"
            :disabled="isReadOnly"
            :maxlength="3000"
            :error="errors[0]"
            :custom-error-msg="'Este campo es requerido'"
          />
        </validation-provider>
      </div>

      <div>
        <div class="color-black font-14 my-1">
          Servicios educativos (aprovechamiento, acomodos):
        </div>
        <validation-provider :rules="'required'" v-slot="{ errors }">
          <custom-text-area
            id="educationalServicesInput"
            v-model="value.educationalServices"
            placeholder="Escribe un comentario"
            :disabled="isReadOnly"
            :maxlength="3000"
            :error="errors[0]"
            :custom-error-msg="'Este campo es requerido'"
          />
        </validation-provider>
      </div>
    </validation-observer>
  </div>
</template>
<script>
import SectionTitle from 'SectionTitle';
import CustomTextArea from '@quisit/custom-text-area';
import CustomRadio from '@/components/common/CustomRadioBorder';
import Error from '@/components/common/Error.vue';
import referralService from '@/services/api/referralsandequipments.api';
import mixAlert from '@/mixins/alert.mixin';
import TABS from '@/utils/constants/evaluationTabs';

export default {
  name: 'Tab-IIIa',
  mixins: [mixAlert],
  components: {
    SectionTitle,
    CustomTextArea,
    CustomRadio,
    Error,
  },
  props: {
    isReadOnly: {
      type: Boolean,
      default: () => false,
    },
    code: {
      type: String,
      default: () => '',
    },
    referralId: {
      type: Number,
      default: () => 0,
    },
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    value: {
      familyComponentConstitutedBy: null,
      medicalHistory: [],
      maintainsMedicalMonitoringWith: null,
      diagnostics: null,
      educationalServices: null,
    },
  }),
  async mounted() {
    await this.initData();
  },
  computed: {
    yesNoOptions() {
      return (checked) => [
        { label: 'SI', value: true, check: checked === true },
        { label: 'NO', value: false, check: checked === false },
      ];
    },
  },
  methods: {
    async initData() {
      await this.getMedicalInfo();
      this.$emit('loaded', TABS.IIIa);
    },
    async getMedicalInfo() {
      const { data } = await referralService.getReferralMedicalInfo(
        this.referralId
      );
      this.value = data;
    },
    async validate() {
      const valid = await this.$refs[`${this.code}-validator`].validate();
      return {
        valid,
        message: valid ? '' : 'Completar el historial médico',
      };
    },
    async save(showMessage = true) {
      referralService
        .saveReferralMedicalInfo(this.referralId, this.value)
        .then(async () => {
          if (showMessage) {
            this.ShowToast(
              'Éxito',
              'Información ha sido guardada exitosamente.',
              'success'
            );
          }
        })
        .catch((error) => {
          this.ShowToast('Alerta', error?.response?.data.message, 'error');
        });
    },
    onQuestionChange(value, question) {
      this.$forceUpdate();
      if (!value) question.explain = null;
    },
  },
};
</script>
<style lang="scss"></style>
